/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Insider } from '../models/insider';
@Injectable({
  providedIn: 'root',
})
class InsidersByIssuerService extends __BaseService {
  static readonly getInsidersByIssuerPath = '/insiders/{issuerId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param issuerId undefined
   * @return a list of insiders for issuer
   */
  getInsidersByIssuerResponse(issuerId: number): __Observable<__StrictHttpResponse<Array<Insider>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/insiders/${encodeURIComponent(String(issuerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Insider>>;
      })
    );
  }
  /**
   * @param issuerId undefined
   * @return a list of insiders for issuer
   */
  getInsidersByIssuer(issuerId: number): __Observable<Array<Insider>> {
    return this.getInsidersByIssuerResponse(issuerId).pipe(
      __map(_r => _r.body as Array<Insider>)
    );
  }
}

module InsidersByIssuerService {
}

export { InsidersByIssuerService }
